import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { EmbalagensDespachoService } from '../../../services/embalagens-despacho.service';
import { PesagemVolumesServiceV2, PesagemVolumeViewModel } from '../../../services-v2/pedidos/pesagem-volumes-v2.service';
import { finalize } from 'rxjs/operators';
import { markFormGroupTouched } from '@utils';

@Component({
  selector: 'app-pesagem-volumes',
  templateUrl: './pesagem-volumes.component.html',
  styleUrls: ['./pesagem-volumes.component.css']
})
export class PesagemVolumesComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild('modalVolumes', { static: true }) modalVolumes;
  volumes: PesagemVolumeViewModel[] = [];
  editando = false;
  despachoForm: AbstractControl;
  embalagens = [];
  quantidadeVolumes = 0;

  constructor(
    private embalagemService: EmbalagensDespachoService,
    private pesagemVolumesServiceV2: PesagemVolumesServiceV2
  ) {
    super();
  }

  setForm() {
    this.cadastroForm = new FormGroup({
      id: new FormControl(0),
      embalagem: new FormControl(null, [Validators.required]),
      pesoEmbalagem: new FormControl(null, [Validators.required]),
      pesoVolume: new FormControl(null, [Validators.required]),
      nomeEmbalagem: new FormControl(null),
    });
  }

  ngOnInit() {
    this.setForm();
    this.getEmbalagens();
  }

  get pedidoId() {
    return this.despachoForm?.get('pedidoId')?.value ?? this.prop.pedidoId;
  }

  getEmbalagens() {
    this.loading['embalagens'] = true;
    this.embalagemService.getAll()
      .pipe(finalize(() => this.loading['embalagens'] = false))
      .subscribe(res => {
        this.embalagens = res;
      });
  }

  show() {
    this.modalVolumes.show();
    this.despachoForm = this.prop.despachoForm;
    this.quantidadeVolumes = this.prop.quantidadeVolumes;
    this.carregarVolumesExistentes();
  }

  async carregarVolumesExistentes() {
    try {
      this.loading['volumes'] = true;
      this.volumes = await this.pesagemVolumesServiceV2.getVolumes(this.pedidoId);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['volumes'] = false;
    }
  }

  adicionarVolume() {
    this.editando = true;
  }

  onEmbalagemChanged(event) {
    const pesoEmbalagem = (event || {})['pesoEmbalagem'];
    const nomeEmbalagem = (event || {})['nomeEmbalagem'];
    this.cadastroForm.get('pesoEmbalagem').setValue(pesoEmbalagem);
    this.cadastroForm.get('nomeEmbalagem').setValue(nomeEmbalagem);
  }

  async submitFormEmbalagem() {
    if (this.cadastroForm.invalid) {
      return;
    }

    try {
      this.loading['salvar'] = true;
      await this.pesagemVolumesServiceV2.salvarVolumes({
        pedidoId: this.pedidoId,
        volume: this.cadastroForm.value
      });

      await this.carregarVolumesExistentes();
      this.cancelaDigitacao();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['salvar'] = false;
    }
  }

  cancelaDigitacao() {
    this.setForm();
    this.editando = false;
  }

  async excluirVolume(id: number) {
    try {
      this.loading[`excluir-${id}`] = true;
      await this.pesagemVolumesServiceV2.excluirVolume(id);
      this.volumes = this.volumes.filter(volume => volume.id !== id);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading[`excluir-${id}`] = false;
    }
  }

  editarVolume(volume: PesagemVolumeViewModel) {
    this.cadastroForm.patchValue(volume);
    this.editando = true;
  }

  finishPesagem() {
    this.closed.emit(this.volumes);
    this.modalVolumes.hide();
  }

  onClose(): void {
    this.closed.emit();
  }
}
